export const translationEn = {
  'general-statistic-active': 'Active',
  'executor-subscription': 'Subscription',
  'executor-subscriptions': 'Subscriptions',
  'executor-has-subscriptions': 'Has subscriptions',
  'executor-unit-service': 'Service',
  'active-orders': 'Active',
  'Blocked-statistic': 'Blocked',
  'canceled-status': 'Canceled',
  'coordinates-ok': 'Available',
  'coordinates-invalid': 'Invalid',
  'Finish-time': 'Finish time',
  'general-information': 'General information',
  'general-statistics-idle': 'Idle',
  'end-user-order-insurance-text': 'When canceling insurance, an automatic refund is provided. If the insurance was paid for by bank card, the funds will be returned to the client’s card. If the insurance was paid on the balance, the operation of writing off funds from the balance will be cancelled. Affiliate remuneration, according to established conditions, will also be canceled.',
  new_ones: 'New',
  'order-status-active': 'Active',
  'order-status-booked': 'Booked',
  'order-status-available': 'Available',
  'order-status-not_available': 'Not available',
  'order-status-on_charge': 'On charge',
  'order-status-at_warehouse': 'At warehouse',
  'order-status-service_mode': 'Service mode',
  'order-status-under_repair': 'Under Repair',
  'order-status-donor': 'Donor',
  'order-status-stolen': 'Stolen',
  'require_end_user_bank_card-enabled': 'Enabled',
  'require_end_user_bank_card-off': 'Off',
  'region-boundaries-info-text':  'Use the map tools to draw the region boundaries. Once the points are connected, click “Save”',
  'geofence-boundaries-info-text': 'Use the map tools to draw the geofence boundaries. Once the points are connected, click “Save”',
  'geofence-boundaries-tech-type-info-text': 'Use the map tools to draw the technician’s work area. After connecting the points, click “Save”',
  'geofence-boundaries-demand-type-info-text': 'Use the map tools to draw the boundaries of the demand assessment area. After connecting the points, click “Save”.',
  voltage_abbreviation: 'V',
  day_: 'days',
  hour_: 'hours',
  'schedule-plan': 'Schedule',
  'Electric-bikes': 'Electric bikes',
  'maintenance-expired': 'Expired',
  'subscription-fee-amount-value': 'Value',
  REPLENISH_USER_BALANCE_ERROR_MESSAGE: 'The service for replenish the balance using the {{paymentSystem}} payment system is not available. Please contact technical support.',
  'Averages-statistic': 'Average duration of the state of active objects in the specified period',
  'Object-statistic-description': 'Objects that were changed to the status Available in the specified period',
  'Balance-statistic': 'Balance',
  'has-item-yes': 'Yes',
  'has-item-no': 'No',
  'osm-hint': 'Free world map. Used by default in the system. Available without API key.',
  'gomap-hint': 'Free national map of Azerbaijan. Available without API‑key.',
  'google-maps-hint': 'Official Google Maps. It\'s necessary to have an API‑key, which can be obtained from the official website: <a href="https://mapsplatform.google.com/" target="_blank">https://mapsplatform.google.com/</a>',
  'google-maps-api-key-hint': 'Enter the API‑key obtained from the official website: <a href="https://mapsplatform.google.com/" target="_blank">https://mapsplatform.google.com/</a>',
  'google-roadmap-hint': 'A display mode that represents a classic schematic map of streets and roads.',
  'google-hybrid-hint': 'A display mode that combines satellite images with a map of roads, streets, and feature names superimposed on them.',
  'default-map-hint': 'Select the map that will be displayed to you and other your users by default.',
  'altitude-region-hint': 'To filter invalid coordinates by altitude, you should set the acceptable altitude range for the region. Use a topographic map of the area to get such information. Filtering is only applied to online messages to prevent outliers and to pin the unit on the map using the latest valid coordinates. The actual coordinates sent by the equipment are saved in the message history. Please note that for filtering to work, both the minimum and maximum altitude values must be entered, and the unit must be manually assigned to the region',
};
